import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import PackageTraking from "../../../components/PackageTraking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import AllUsers from "../Packages/AllUsers";
import PackagesUserwise from "../Packages/PackagesUserwise";
import AllNoSuites from "./AllNoSuites";
import NoSuitePackages from "./NoSuitePackages";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import {
  getAllSuites,
  getMySuiteDetails,
  getRoutePartners,
  getShelfPackages,
  getWareHouses,
} from "../../../helper/functions";
import {
  setActiveComponent,
  setPackages,
  setRequests,
  setSelectedPackage,
  setSelectedRequest,
  setActiveItem,
} from "../../../store/commonSlice";

function NoSuites() {
  const dispatch = useDispatch()
  const { open } = useContext(SidebarContext);
  const [packageActiveData, setPackageActiveData] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({
    routePartnerId: "",
    warehouseId: "",
  });
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });
  const user = useSelector((state) => state.auth.value);

  const getRoutePartner = async () => {
    const routerPartners = await getRoutePartners([
      {
        key: "isDeleted",
        operator: "==",
        value: false,
      },
    ]);
    setFilterOptions({ routePartners: routerPartners, warehouses: [] });
    console.log(routerPartners, "routePartner");
  };

  const getWarehouse = async (routerPartnerId) => {
    if (routerPartnerId) {
      const data = await getWareHouses({ routePartnerId: routerPartnerId });
      setFilterOptions((prev) => ({ ...prev, warehouses: data }));
    }
  };

  const getPackages = async () => {
    try {
      const extra= [];
      if (selectedFilters?.routePartnerId) {
        extra.push({
          key: "routePartnerId",
          operator: "==",
          value: selectedFilters?.routePartnerId,
        });
      }
      if (selectedFilters?.warehouseId) {
        extra.push({
          key: "routePartnerMainAddressId",
          operator: "==",
          value: selectedFilters?.warehouseId,
        });
      }
      const shelfPackage = await getShelfPackages([
        ...extra,
        {
          key: "isNoSuite",
          operator: "==",
          value: true,
        },
      ]);
      console.log(shelfPackage,"shelfPackage");
      
        dispatch(setRequests(shelfPackage));
      // dispatch(setPackages(shelfPackage));
    } catch (error) {
      // setLoading(false);
      console.log(error, "error");
    }
  };


  const userClickHandler = async (item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedRequest(item));
    dispatch(setSelectedPackage(null));
    dispatch(setActiveItem(null));
  };

  const packageClickHandler = async (item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedPackage(item));
    dispatch(setActiveItem(null));
  };

  useEffect(() => {
    try {
      getRoutePartner();
    } catch (err) {
      console.log(err, "err");
    }

    return () => {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedRequest(null));
    };
  }, []);

  useEffect(()=>{
    getPackages()
  },[selectedFilters])

  const changeFilterHandler = async (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    dispatch(setSelectedRequest(null));
    dispatch(setSelectedPackage(null));
    getWarehouse(filter?.routePartnerId);
  };

  useEffect(() => {
    if (user?.routePartnerId) {
      setSelectedFilters((prev) => ({
        ...prev,
        routePartnerId: user?.routePartnerId,
      }));
      getWarehouse(user?.routePartnerId);
    }
  }, [user]);

  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.packageShipmentCreationDate
        ? new Date(
            packageActiveData?.packageShipmentCreationDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: "Packing",
      date: packageActiveData?.preparedShipmentDate
        ? new Date(
            packageActiveData?.preparedShipmentDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: "Send",
      date: "-",
    },
    { label: "Done", date: "-" },
  ];

  const activeStep =
    packageActiveData?.packageStatus === "PREPARE_SHIPMENT_REQUEST_APPROVED" ? 2 : 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader pageTitle={"No Suites Packages"} selectedFilters={selectedFilters} filterOptions={filterOptions} changeFilterHandler={changeFilterHandler} />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllNoSuites
              userClickHandler={userClickHandler}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ borderLeft: "1px solid #E5E5E8" }}
          >
            <NoSuitePackages
              packageClickHandler={packageClickHandler}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "86vh" }}
              className="custom-scrollbar"
            >
              <PackageTraking
                packageActiveData={packageActiveData}
                collection="shelfPackages"
                steps={steps}
                activeStep={activeStep}
                pageName="NoSuites"
              />
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default NoSuites;
